import React from 'react';
import MetaTags from 'react-meta-tags';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './HomeHeaderBrandsAlternate.scss';

import { openAuthModal } from '../../../Actions/UIActions';
import usePageLoadEvent from '../../../CustomHooks/usePageLoadEvent';
import ScrollToTop from '../../General/ScrollToTop';

const BRAND_HEADER_CONTENT = {
  1: {
    title: 'Power your creator strategy with tools built for growth, not guesswork.',
    description: 'The platform high-growth brands use to scale.',
    actionText: 'Learn More',
  },
  2: {
    title: 'How fast-growing brands build scalable creator programs.',
    description: 'Immediately tap into over 135k creators already on ShopMy.',
    actionText: 'Get a Demo',
  }
}

const HomeHeaderBrandsAlternate = props => {
  const { headerContentKey } = props;
  const seo_header = 'ShopMy | World Class Creator Marketing';
  const seo_description = 'Everything you need to build a world class creator marketing program.';

  usePageLoadEvent('Home - Brands - Page View', { version: headerContentKey });

  const getDemo = () => {
    props.openAuthModal('apply-brands');
  };

  return (
    <div className='home-header-brands-alternate-outer-container'>
      <MetaTags>
        <title>{seo_header}</title>
        <meta property='og:title' content={seo_header} />
        <meta property='description' content={seo_description} />
        <meta property='og:description' content={seo_description} />
        <meta property='og:image' content='https://static.shopmy.us/social-share-banner.png' />
      </MetaTags>
      <ScrollToTop />
      <div className='home-header-brands-alternate-inner-container'>
        <div className='spacer' />
        <div className='main-container'>
          <div className='title-section'>
            <h1 className='title'>
              {BRAND_HEADER_CONTENT[headerContentKey].title}
            </h1>
            <h2 className='subtitle'>{BRAND_HEADER_CONTENT[headerContentKey].description}</h2>
            <div className='actions'>
              <div onClick={getDemo} className='action primary'>
                {BRAND_HEADER_CONTENT[headerContentKey].actionText}
              </div>
            </div>
          </div>
          <div className='image-section'>
            <img src='https://static.shopmy.us/Home/Brands/brand-image-stack.png' alt='ShopMy Brand Preview' />
          </div>
        </div>
      </div>
    </div>
  );
};

HomeHeaderBrandsAlternate.propTypes = {
  user: PropTypes.object.isRequired,
  openAuthModal: PropTypes.func.isRequired,
  headerContentKey: PropTypes.number.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  openAuthModal
})(HomeHeaderBrandsAlternate);
